import { object } from 'prop-types';
import React from 'react';

import TextField from '../../FormFields/TextField';

const OccurrenceCountFields = ({
    errors,
    touched,
    values,
    ...props
}) => (
    <TextField
        autoComplete="off"
        errors={errors.aggregateCount}
        label={`${process.env.isRuleAggregateChange ? 'Duration' : 'Aggregate Count'}`}
        helperText={`${process.env.isRuleAggregateChange ? 'Enter a value in minutes' : ''}`}
        name="ruleAggregateCount"
        required
        touched={touched.ruleAggregateCount}
        type="number"
        value={values.ruleAggregateCount}
        {...props}
    />
);

OccurrenceCountFields.defaultProps = {
    errors:  {},
    touched: {},
    values:  {}
};

OccurrenceCountFields.propTypes = {
    errors:  object,
    touched: object,
    values:  object
};

export default OccurrenceCountFields;
